(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGOWebapi"), require("VueDemi"), require("FEGOVue"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGOWebapi", "VueDemi", "FEGOVue"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/invite-public-share/render"] = factory(require("FEGOWebapi"), require("VueDemi"), require("FEGOVue"));
	else
		root["/fego/component/invite-public-share/render"] = factory(root["FEGOWebapi"], root["VueDemi"], root["FEGOVue"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5113__, __WEBPACK_EXTERNAL_MODULE__9906__, __WEBPACK_EXTERNAL_MODULE__9666__) => {
return 